let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eq0Fx")).then(() => parcelRequire('1eKr8'));